import { connect } from 'react-redux';
import { fetchReviews, clearReviews } from 'marketing/ducks';
import { getSubCategory } from 'common/ducks/categories';
import Reviews from 'landing_pages/components/reviews';

const mapStateToProps = ({ categories, marketing }, { subcategoryId }) => {
  return {
    items: marketing.reviews,
    fetching: marketing.fetchingReviews,
    subcategory: getSubCategory(categories, subcategoryId)
  };
}

export default connect(mapStateToProps, {
  fetch: fetchReviews,
  clear: clearReviews
})(Reviews);
